import MonthlyProceduresDashboard from "./MonthlyProceduresDashboard";
import AssessorsRankingDashboard from "./AssessorsRankingDashboard";
import CardStatusDetailDashboard from "./CardStatusDetailDashboard";

const dashboardComponentMap = {
  // Chave deve corresponder ao DB (coluna configuracoes da model programas)
  monthly_procedures: MonthlyProceduresDashboard,
  assessors_ranking: AssessorsRankingDashboard,
  cards_status_detail: CardStatusDetailDashboard,
  // Adicione outras chaves/componentes conforme necessário
};

export default dashboardComponentMap;
